import { createContext, useContext } from 'react';
import { EducationTooltipVariant } from '../types';

interface EducationTooltipContextType {
    onClose: () => void;
    setInView: (inView: boolean) => void;
    variant: EducationTooltipVariant;
}

export const EducationTooltipContext = createContext<EducationTooltipContextType>({} as EducationTooltipContextType);

export const useEducationTooltipContext = () => {
    const context = useContext(EducationTooltipContext);
    if (context === undefined) {
        throw new Error('useEducationTooltipContext must be used within a EducationTooltipContextProvider');
    }
    return context;
};
